﻿import { ParagrafViewModel } from '../Models/ResultViewModel';

export interface ParagraferState {
    paragrafer?: Array<ParagrafViewModel>;
    sisteAktiveLamell?: string;
    loading: boolean;
    firstLoadReady?: boolean;
    modalOpen?: string;
    kapittelMerknadOverskrift?: string;
    kapittelMerknadTekst?: string;
    kapittelMerknadLenketekst?: string;
    visFeilmelding: boolean;
}

export const SET_PARAGRAFER = 'SET_PARAGRAFER';
export const UPDATE_PARAGRAFER = 'UPDATE_PARAGRAFER';
export const SET_FEILMELDING = 'SET_FEILMELDING';

export interface SetParagraferAction {
    type: typeof SET_PARAGRAFER;
    payload: ParagraferState;
}

interface UpdateParagraferAction {
    type: typeof UPDATE_PARAGRAFER;
    payload: ParagraferState;
}

interface SetFeilmeldingAction {
    type: typeof SET_FEILMELDING;
    payload: {
        loading: boolean,
        visFeilmelding: boolean,
    }
}

export type StateActionTypes = SetParagraferAction | UpdateParagraferAction | SetFeilmeldingAction;